import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bgImage from "./bracu_image.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  const [identifier, setIdentifier] = useState(""); // email or PIN
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!identifier || !password) {
      toast.warning("Please enter both email and password!");
      return;
    }

    try {
      const res = await axios.post(
        "https://api.bbsfacultyprofile.com/api/login",
        { identifier, password },
        { withCredentials: true }
      );

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("role", res.data.role);

        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${res.data.token}`;

        if (res.data.role === "admin") {
          toast.success("Logging in as Admin...", { autoClose: 1000 });
          setTimeout(() => navigate("/admin_dashboard"), 1000);
        } else if (res.data.role === "faculty") {
          toast.success("Logging in as Faculty...", { autoClose: 1000 });
          setTimeout(() => navigate("/dashboard"), 1000);
        } else {
          toast.error("Unknown role. Contact admin.");
        }
      } else {
        toast.error("Login failed. No token received.");
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error(err.response?.data?.message || "Login failed");
    }
  };

  const handleForgotPassword = () => {
    const ForgotPasswordToast = ({ closeToast }) => {
      const [email, setEmail] = useState("");

      const submitEmail = async () => {
        if (!email) {
          toast.warning("Please enter an email!");
          return;
        }

        try {
          const res = await axios.post(
            "https://api.bbsfacultyprofile.com/api/forgot-password/check",
            { email }
          );

          if (res.data.token) {
            toast.success("Valid reset token found! Redirecting...");
            setTimeout(
              () => navigate(`/reset-password/${res.data.token}`),
              1000
            );
          } else {
            toast.info(res.data.message);
          }
        } catch (err) {
          toast.error(err.response?.data?.message || "Error checking token.");
        }
      };

      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button onClick={submitEmail}>Submit</button>
        </div>
      );
    };

    toast.info(<ForgotPasswordToast />, {
      autoClose: false,
      closeOnClick: false,
    });
  };

  return (
    <div
      style={{
        height: "100vh",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          padding: "40px",
          borderRadius: "12px",
          width: "350px",
          boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          User Login
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column" }}
        >
          Email:
          <input
            type="text"
            placeholder="Enter your Email"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
            style={{
              padding: "10px",
              margin: "10px 0",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
          Password:
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              padding: "10px",
              margin: "10px 0",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
          <button
            type="submit"
            style={{
              backgroundColor: "#2654b6ff",
              color: "white",
              padding: "10px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              marginTop: "10px",
              fontWeight: "bold",
            }}
          >
            Login
          </button>
        </form>

        <p style={{ marginTop: "15px", textAlign: "center" }}>
          Don't have an account?{" "}
          <button
            onClick={() => navigate("/register")}
            style={{
              background: "none",
              border: "none",
              color: "#2196F3",
              cursor: "pointer",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            Register
          </button>
        </p>

        <p style={{ textAlign: "center", marginTop: "10px" }}>
          <button
            onClick={handleForgotPassword}
            style={{
              background: "none",
              border: "none",
              color: "#2196F3",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Forgot Password?
          </button>
        </p>

        <p style={{ textAlign: "center", marginTop: "10px" }}>
          <button
            onClick={() => navigate("/")}
            style={{
              background: "none",
              border: "none",
              color: "#2854d9ff",
              cursor: "pointer",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            Back to Home
          </button>
        </p>
      </div>

      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </div>
  );
}
